import styled from '@emotion/styled'

import { ButtonBase } from '@mui/material'
import { theme } from 'styles/theme/hav-theme'

export const ModalContent = styled('div')`
  max-width: 690px;
  color: ${theme.colors.neutral.high};
  .MuiFormControl-root {
    margin-bottom: ${theme.spacing.xm};
  }
`
export const ModalInfo = styled('div')`
  margin-bottom: ${theme.spacing.lg};
  width: 690px;
  max-width: 100%;
  white-space: normal;
  text-align: left;
`

export const WrapTableStyled = styled.div`
  tbody td {
    border: ${theme.shapes.borderWidth.none};
  }
  tbody tr:nth-of-type(even) {
    background-color: ${theme.colors.neutral[100]};
    border-radius: ${theme.spacing.xs};
  }
  .MuiTableCell-head {
    font-size: ${theme.typography.sizes.xs};
    font-family: ${theme.typography.family.primary};
    font-weight: ${theme.typography.weight.lg};
    line-height: normal;
    background-color: ${theme.colors.neutral.white};
    color: ${theme.colors.neutral.black};
    padding: 0 ${theme.spacing.xm} ${theme.spacing.sm};
  }
  thead::after {
    height: ${theme.spacing.sm};
  }

  tbody {
    tr {
      .MuiTableCell-body {
        font-family: ${theme.typography.family.primary};
        font-size: ${theme.typography.sizes.sm};
        font-weight: ${theme.typography.weight.sm};
        line-height: normal;
      }
    }
  }
`

export const WrapDesktopTableStyled = styled.div`
  overflow-x: auto;
  overflow-y: scroll;
  margin-bottom: ${theme.spacing.xm};

  .MuiFormControl-root {
    margin-bottom: ${theme.spacing.xm};
  }
  ::-webkit-scrollbar {
    width: ${theme.spacing.sm};
  }

  ::-webkit-scrollbar-track {
    background: ${theme.colors.neutral.clear};
    border-radius: ${theme.shapes.borderRadius.md};
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.neutral.light};
    border-radius: ${theme.shapes.borderRadius.md};
    border: none;
  }

  display: flex;
  width: 100%;
`
export const ActionButton = styled(ButtonBase)`
  background: ${theme.colors.neutral.white};
  color: ${theme.colors.primary.main};
  padding: ${theme.spacing.xs} !important;
  border-radius: ${theme.spacing.xs};

  svg {
    path {
      fill: ${theme.colors.primary.main};
    }
  }

  width: auto;

  transition: background 0.3s ease;
  :hover {
    background: ${theme.colors.neutral.clear};
  }
`
